import presetRecipients from 'constants/presetRecipients';

export type RecipientOption = {
  id: string;
  value: string;
  labelKeys: string[];
  recipientKey?: string;
};

export const recipientOptions: RecipientOption[] = [
  {
    id: 'recipients-partners',
    value: presetRecipients.PARTNERS,
    labelKeys: ['Partners'],
    recipientKey: 'PARTNERS',
  },
  {
    id: 'recipients-beneficiaries',
    value: presetRecipients.BENEFICIARIES,
    labelKeys: ['Beneficiaries'],
    recipientKey: 'BENEFICIARIES',
  },
  {
    id: 'recipients-investors',
    value: presetRecipients.INVESTORS,
    labelKeys: ['Investors', 'ConvertibleNote'],
    recipientKey: 'INVESTORS',
  },
  {
    id: 'recipients-directors',
    value: presetRecipients.DIRECTORS,
    labelKeys: ['AdminOrgan'],
    recipientKey: 'DIRECTORS',
  },
  {
    id: 'recipients-all',
    value: presetRecipients.ALL,
    labelKeys: ['All'],
  },
  {
    id: 'recipients-custom',
    value: presetRecipients.CUSTOM,
    labelKeys: ['Personalized'],
  },
];
